<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M6.14282 19H9.48907V13.0578H14.7966V19H18.1428V10L12.1428 5.48077L6.14282 10V19ZM4.64282 20.5V9.25002L12.1428 3.60577L19.6428 9.25002V20.5H13.2966V14.5578H10.9891V20.5H4.64282Z" fill="currentColor"/>
</svg>
